import classNames from 'classnames';
import * as React from 'react';
import { usePlannerContext } from '../../Planner/Context/PlannerContextProvider';
import { usePlannerTranslations } from '../../Planner/Context/PlannerTranslationsContextProvider';
import type { PlannerFilterType } from '../../Planner/Context/types';
import { SubjectsFilter } from '../../SubjectsFilter/SubjectsFilter';
import { Collapse } from '~/Partials/Collapse/Collapse';
import styles from './PlannerFilter.module.css';

export interface PlannerFilterProps {
    className?: string;
}

export const PlannerFilter: React.FC<PlannerFilterProps> = props => {
    const { className } = props;
    const { currentBookmark, filterOptions, setCurrentFilter, currentFilter } = usePlannerContext();
    const { filterSubjects } = usePlannerTranslations();

    const hasAtLeastTwoDifferentCategories = filterOptions.size > 2;
    const displayFilters = currentBookmark.contextKey === 'subjects' && hasAtLeastTwoDifferentCategories;

    return (
        <Collapse
            isOpen={displayFilters}
            className={classNames(styles.PlannerFilter, !displayFilters && styles['Variant--hidden'], className)}
            withMarginTransition
        >
            <SubjectsFilter
                name="Planner Filters"
                currentValue={currentFilter}
                label={filterSubjects}
                options={filterOptions}
                onChange={filter => setCurrentFilter(filter as PlannerFilterType)} // TODO: [OnlinePlanner] Fix this - should be generic
            />
        </Collapse>
    );
};
